import PageBanner from "app/components/ui/PageBanner"
import HelmetTitle from "app/meta/HelmetTitle"
import React from 'react'
import './styles/ServicesPage.css'
import MakeAppointment from "app/components/homepage/MakeAppointment"
import PageSection from "app/components/ui/PageSection"
import { pediatricsData, pediatricsData2 } from "app/data/servicesData"
import sectionImg1 from 'app/assets/images/pediatrics-1.jpg'
import sectionImg2 from 'app/assets/images/pediatrics-2.jpg'
import sectionImg3 from 'app/assets/images/pediatrics-3.jpg'
import IconContainer from "app/components/ui/IconContainer"
import SiteGrid from "app/components/ui/SiteGrid"
import IconsBarSection from "app/components/ui/IconsBarSection"

export default function PediatricsPage() {

  const pediatricsGridRender = pediatricsData?.map((item, index) => {
    return <div
      key={index}
      className="grid-item"
    >
      <IconContainer
        icon={item.icon}
        iconSize={20}
        dimensions={40}
        iconColor="var(--primary)"
        bgColor="var(--extraLightPrimary)"
      />
      <h4>{item.title}</h4>
      <p>{item.text}</p>
    </div>
  })

  return (
    <div className="pediatrics-page services-page">
      <HelmetTitle title="Pediatrics" />
      <PageBanner
        title="Pediatrics"
        subtitle="Providing comprehensive care for children from birth to young adulthood."
      />
      <div className="page-content">
        <PageSection
          subtitle="Understanding Pediatrics?"
          title="What You Need to Know About Pediatrics"
          text={<div className="pediatrics-grid">
            {pediatricsGridRender}
          </div>}
          img={sectionImg1}
          className="pediatrics-section-1"
        />
        <PageSection
          direction="rtl"
          subtitle="Developmental Milestones"
          title="What Every Parent Should Know"
          text={<p>
            Pediatricians are trained to monitor children's developmental milestones
            and identify any potential delays or concerns. By tracking a child's
            physical, cognitive, and social-emotional development, pediatricians
            can provide guidance and support to parents to help their child reach
            their full potential.
            <br /><br />
            pediatricians may track a child's language development, motor skills,
            and social interactions. If a child is not meeting milestones in these
            areas, pediatricians may recommend further evaluation or provide resources
            for early intervention services.
          </p>}
          img={sectionImg2}
        />
        <PageSection
          subtitle="Food Allergies"
          title="Understanding Symptoms and Treatment Options"
          text={<><p>
            Food allergies are common in children, and they can cause a variety of
            symptoms. Here are some guidlines and tips to help manage your child's
            food allergies and be prepared in case of an emergency.
          </p>
            <ul>
              <li>Common food allergens in children include milk, eggs, peanuts, tree nuts, soy, wheat, fish, and shellfish.</li>
              <li>Symptoms of a food allergy can range from mild (e.g., hives, rash, stomach pain) to severe </li>
              <li>Avoiding the allergen is the best way to prevent an allergic reaction.</li>
              <li>In some cases, children may outgrow their food allergies over time.</li>
              <li>Treatment for a food allergy may involve emergency medication, antihistamines, or corticosteroids.</li>
            </ul>
          </>}
          img={sectionImg3}
          className="pediatrics-section-3"
        />
        <SiteGrid className="section section-3">
          <IconsBarSection
            title="Caring for Your Child's Health"
            subtitle="Our Pediatrics Services"
            data={pediatricsData2}
          />
        </SiteGrid>
        <MakeAppointment />
      </div>
    </div>
  )
}
